import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-invoice-sales-summary',
    templateUrl: './invoice-sales-summary.component.html',
    styleUrls: ['./invoice-sales-summary.component.scss'],
    standalone: false
})
export class InvoiceSalesSummaryComponent implements OnInit {

    constructor() { }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.invoiceSalesSummary;
    chartSearchFilters: widgetFilters[] = [widgetFilters.customer,
        widgetFilters.locations,
        widgetFilters.dateRange,
        widgetFilters.salesPerson,
        widgetFilters.technicians,
        widgetFilters.invoiceStatus,
        widgetFilters.onCallRegion,       
        widgetFilters.class];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
